import { Button } from "@/components/ui/button";

export default function Header({
  currentUser,
  isArtistUser,
  isVenueUser,
  theme,
  onLogout,
  onSwitchAuthMode,
  onThemeToggle,
}) {
  return (
    <header className="app-header sticky top-0 z-50">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2.5">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-zinc-900 text-xs font-bold tracking-wider text-white dark:bg-amber-500 dark:text-zinc-950">
            OT
          </span>
          <span className="text-sm font-semibold tracking-tight text-zinc-900 dark:text-zinc-50">
            Onetrack
          </span>
        </div>
        <div className="flex items-center gap-2">
          {currentUser ? (
            <>
              <div className="hidden sm:block text-right leading-tight mr-1">
                <p className="text-sm font-medium text-zinc-900 dark:text-zinc-100">
                  {currentUser.name}
                </p>
                <p className="text-[11px] uppercase tracking-wide text-zinc-400 dark:text-zinc-500">
                  {isArtistUser ? "Artist" : isVenueUser ? "Venue" : "Member"}
                </p>
              </div>
              <Button type="button" className="btn-secondary text-sm" onClick={onLogout}>
                Log out
              </Button>
            </>
          ) : (
            <>
              <Button
                type="button"
                className="btn-secondary text-sm"
                onClick={() => onSwitchAuthMode("login")}
              >
                Log in
              </Button>
              <Button
                type="button"
                className="btn-primary text-sm"
                onClick={() => onSwitchAuthMode("register")}
              >
                Get started
              </Button>
            </>
          )}
          <Button
            type="button"
            className="btn-secondary text-xs px-3"
            onClick={onThemeToggle}
            title="Toggle theme"
          >
            {theme === "dark" ? "☀" : "☽"}
          </Button>
        </div>
      </div>
    </header>
  );
}
